import { IListResponse, XHRInstance } from "@sembark-travel/xhr"

export type THotelAddonApplicableOn =
	| "custom_days"
	| "excluding_checkout"
	| "including_checkout"

export type THotelAddonPriceMode = "per_quantity" | "per_room" | "per_person"

export type THotelAddonValidity = {
	id: number
	from: string
	to: string
	weekdays_bitmap: number
	weekdays_bitmap_str: string
}

export type THotelAddon = {
	id: number
	hotel_id: number
	code: string
	name: string
	description: string | null
	applicable_on: THotelAddonApplicableOn
	is_service_date_flexible: boolean
	mandatory_dates: Array<string>
	price_mode: THotelAddonPriceMode
	min_child_age: number
	tax_percentage: string
	currency: string
	rate_before_tax?: string //can be nullable in future when pricing mode will be 'per_person'
	per_adult_rate_before_tax?: string
	per_child_rate_before_tax?: string
	image_url: string
	thumb_image_url: string
	created_at: string
	updated_at?: string
	deleted_at: string | null
}

export function hotelAddOnsXHR(xhr: XHRInstance) {
	return {
		async getAddOns(
			hotelId: string | number,
			params?: Record<string, unknown>
		): Promise<IListResponse<THotelAddon>> {
			return xhr
				.get(`/hotels/${hotelId}/ota-addons`, { params })
				.then((resp) => resp.data)
		},
		async createAddOn(
			hotelId: string | number,
			data: FormData
		): Promise<THotelAddon> {
			return xhr
				.post(`/hotels/${hotelId}/ota-addons`, data)
				.then((resp) => resp.data.data)
		},
		async updateAddOn(
			hotelId: string | number,
			id: number,
			data: FormData
		): Promise<THotelAddon> {
			return xhr
				.put(`/hotels/${hotelId}/ota-addons/${id}`, data)
				.then((resp) => resp.data.data)
		},
		async deleteAddOn(id: number): Promise<{ message: string }> {
			return xhr.delete(`/ota-addons/${id}`).then((resp) => resp.data.data)
		},
	}
}
